import { createContext, useContext, useMemo } from 'react';

const RoleContext = createContext(null);

export const RoleProvider = ({ children, isDirector, isEducator, isOperator, isAdvanced, effectiveIsDirector, isRestrictedView }) => {
  const value = useMemo(
    () => ({ isDirector, isEducator, isOperator, isAdvanced, effectiveIsDirector, isRestrictedView }),
    [isDirector, isEducator, isOperator, isAdvanced, effectiveIsDirector, isRestrictedView]
  );
  return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
};

export const useRole = () => {
  const ctx = useContext(RoleContext);
  if (!ctx) throw new Error('useRole deve essere usato dentro RoleProvider');
  return ctx;
};
